<template>
  <card :title="$t('gc-software:lastUpdate')" no-body no-footer>
    <div v-if="!lastExecution" slot="card-table" class="text-center font-italic text-muted p-3">{{ $t('gc-software:none') | capitalize }}</div>

    <table v-else slot="card-table" class="table table-sm mb-0">
      <tbody>
        <tr>
          <td class="text-uppercase">{{ $t('gc-software:dateExecution') | capitalize }}</td>
          <td>{{ lastExecution.creationDate | date }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('gc-software:dateApplication') | capitalize }}</td>
          <td>{{ lastExecution.sendParameters.when | date }}</td>
        </tr>
        <tr>
          <td class="text-uppercase">{{ $t('gc-software:status') | capitalize }}</td>
          <td :class="statusClass">{{ lastExecution.status }}</td>
        </tr>
        <tr v-if="lastExecution.errorMessage">
          <td class="text-uppercase">{{ $t('gc-software:cause') | capitalize }}</td>
          <td class="error-cause">{{ lastExecution.errorMessage }}</td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  props: {
    eui: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      lastExecution: null,
      timeoutRefreshLastExecution: null
    }
  },

  computed: {
    ...mapGetters(['gateway']),

    statusClass () {
      if (this.lastExecution.status === 'OK') return 'text-success'
      else if (this.lastExecution.status === 'PENDING') return 'text-info'
      else if (this.lastExecution.status === 'KO') return 'text-danger'
      else return ''
    }
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.lastExecution = null
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.lastExecution)) return

      this.getLastExecution()
    }
  },

  created () {
    eventBus.$on('gateway-update-started', this.getLastExecution)

    this.getLastExecution()
  },

  destroyed () {
    clearTimeout(this.timeoutRefreshLastExecution)

    eventBus.$off('gateway-update-started', this.getLastExecution)
  },

  methods: {
    async getLastExecution () {
      if (isEmpty(this.gateway)) return

      const params = { eui: this.gateway.eui, action: 'UPDATE_EXECUTE', sort: '-creationDate', page: 1, pageSize: 1 }
      let error, response
      [error, response] = await to(this.$api.getTasks(this.$store.getters.application, params))
      if (!error && response) this.lastExecution = isEmpty(response.data.list) ? null : response.data.list[0]

      // Relaunch timer if still PENDING
      if (this.lastExecution && this.lastExecution.status === 'PENDING') {
        // In case the promise ended after the destruction of the component
        // Check the component status to only relaunch the polling when component is not destroyed
        if (this._isDestroyed || this._isBeingDestroyed) return

        this.timeoutRefreshLastExecution = setTimeout(this.getLastExecution, 15000)
      }

      // Refresh current version if OK
      if (this.lastExecution && this.lastExecution.status === 'OK') {
        eventBus.$emit('gateway-update-success')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .error-cause {
    word-break: break-word;
    white-space: inherit;
  }
</style>
